// 商品系统--分类管理api
import {ServerDistApi} from '@/group-cloud/network/ServerBizApi';

export class CommodityGoodsyApi {

    constructor() {
    }
    protected static groupUrl = '/goods';
    protected static skuGroupUrl = '/sku';

    //获取规格
    public static async getGoodsSpecList(data) {
        let uri = this.groupUrl + '/spec/list';
        return await ServerDistApi.send(uri, data);
    }
    //获取规格数据
    public static async getEditGoodsSpec(data) {
        let uri = this.groupUrl + '/spec/detail';
        return await ServerDistApi.get(uri, data);
    }
    //保存规格
    public static async saveGoodsSpec(data) {
        let uri = this.groupUrl + '/spec/save';
        return await ServerDistApi.send(uri, data);
    }
    //删除规格
    public static async deleteGoodsSpec(data) {
        let uri = this.groupUrl + '/spec/delete';
        return await ServerDistApi.get(uri, data);
    }

    //获取商品分页
    public static async getGoodsList(data) {
        let uri = this.skuGroupUrl + '/list';
        return await ServerDistApi.send(uri, data);
    }

    //获取所有商品不分页
    public static async getAllGoodsList(data) {
        let uri = this.skuGroupUrl + '/all';
        return await ServerDistApi.send(uri, data);
    }

    //获取模糊搜索商品，不包含sku信息
    public static async suggestGoods(data){
        let uri = this.groupUrl + '/suggest';
        return await ServerDistApi.get(uri, data);
    }

    //商品名+69码模糊搜索商品，包含sku信息
    public static async suggestBarCodeGoods(data){
        let uri = this.skuGroupUrl + '/suggestBarCode';
        return await ServerDistApi.get(uri, data);
    }

    //商品名获取模糊搜索商品，包含sku信息
    public static async suggestSkuGoods(data){
        // let uri = this.skuGroupUrl + '/suggest';
        let uri = '/ordering/man/order/items/addByChange';
        // let uri = 'http://utopia558.i234.me:7003/data-dist/api/dist/sku/suggest';  海姆测试
        // return ServerDistApi.asyncTestGet(uri, data);  海姆测试
        // return await ServerDistApi.send(uri, data);
        return await ServerDistApi.send(uri, data);
    }
    public static async suggestSkuGoods1(data){
        let uri = this.skuGroupUrl + '/suggest';
        // let uri = '/ordering/man/order/items/addByChange';
        // let uri = 'http://utopia558.i234.me:7003/data-dist/api/dist/sku/suggest';  海姆测试
        // return ServerDistApi.asyncTestGet(uri, data);  海姆测试
        return await ServerDistApi.get(uri, data);
        // return await ServerDistApi.get(uri, data);
    }

    //获取属性选项
    public static async attrOptions(data){
        let uri = this.groupUrl + '/base/specs';
        return await ServerDistApi.get(uri, data);
    }
    //获取属性值选项
    public static async attrValueOptions(data){
        let uri = this.groupUrl + '/base/spec/values';
        return await ServerDistApi.get(uri, data);
    }

    //保存
    public static async saveGoods(data) {
        let uri = this.skuGroupUrl + '/save';
        return await ServerDistApi.send(uri, data);
    }



    public static async getEditGoods(data) {
        let uri = this.skuGroupUrl + '/get';
        return await ServerDistApi.get(uri, data);
    }

    //删除
    public static async deleteGoods(data){
        let uri = this.skuGroupUrl + '/delete';
        return await ServerDistApi.get(uri, data);
    }
    //获取导出
    public static async handleExport(data) {
        let uri =  this.skuGroupUrl +'/export';
        return await ServerDistApi.send(uri, data);
    }


    //  获取商品列表(带库存)
    public static async getSkuStocks(data) {
        let url = '/stock/skuStocks';
        return await ServerDistApi.send(url, data);
    }

    //箱码商品列表 <查询所有符合规格1的商品>
    public static async getBoxSkuList(data){
        let uri = this.skuGroupUrl + '/boxsku/list';
        return await ServerDistApi.get(uri, data);
    }

    // 当前箱码商品mapping关系查询
    public static async getMappingLeft(data){
        let uri = this.skuGroupUrl + '/mapping/left';
        return await ServerDistApi.get(uri, data);
    }

    // 批量设置达量奖励账户使用比例
    public static async setAccountProp(data){
        let uri = this.skuGroupUrl + '/saveGoodsRebeatPercent';
        return await ServerDistApi.send(uri, data);
    }

    // 查询未映射商品
    public static async reflectGood(data){
        let uri = '/goodsmapping/pagelist';
        return await ServerDistApi.send(uri, data);
    }
}


